const constants = {
  LOGIN_USER: 'LOGIN_USER',
  LOGOUT_USER: 'LOGOUT_USER',
  LOGIN_GOOGLE_USER: 'LOGIN_GOOGLE_USER',
  LOGOUT_GOOGLE_USER: 'LOGOUT_GOOGLE_USER',
  SET_USER_TOKEN: 'SET_USER_TOKEN',
  SET_USER_ROLES: 'SET_USER_ROLES',
  INIT_VIEWER: 'INIT_VIEWER',
  SYNC_VIEWER: 'SYNC_VIEWER',
  REMOVE_VIEWER_DIMENSIONS: 'REMOVE_VIEWER_DIMENSIONS',
  SET_VIEWER_LAYER_SOURCE: 'SET_VIEWER_LAYER_SOURCE',
  SET_VIEWER_GRAYSCALE_SOURCE: 'SET_VIEWER_GRAYSCALE_SOURCE',
  SET_VIEWER_SEGMENTATION_SOURCE: 'SET_VIEWER_SEGMENTATION_SOURCE',
  SET_VIEWER_SEGMENTATION_LAYER_NAME: 'SET_VIEWER_SEGMENTATION_LAYER_NAME',
  SET_VIEWER_TODOS_SOURCE: 'SET_VIEWER_TODOS_SOURCE',
  SET_VIEWER_TODOS_TYPE: 'SET_VIEWER_TODOS_TYPE',
  SET_VIEWER_TODOS_HINT: 'SET_VIEWER_TODOS_HINT',
  SET_VIEWER_ANNOTATION_SELECTION: 'SET_VIEWER_ANNOTATION_SELECTION',
  SET_VIEWER_ANNOTATION_TOOL: 'SET_VIEWER_ANNOTATION_TOOL',
  SET_VIEWER_CROSS_SECTION_SCALE: 'SET_VIEWER_CROSS_SECTION_SCALE',
  SET_VIEWER_CAMERA_POSITION: 'SET_VIEWER_CAMERA_POSITION',
  SET_VIEWER_CAMERA_PROJECTION_SCALE: 'SET_VIEWER_CAMERA_PROJECTION_SCALE',
  SET_VIEWER_CAMERA_PROJECTION_ORIENTATION: 'SET_VIEWER_CAMERA_PROJECTION_ORIENTATION',
  SET_VIEWER_SEGMENTS: 'SET_VIEWER_SEGMENTS',
  SET_VIEWER_SEGMENT_COLORS: 'SET_VIEWER_SEGMENT_COLORS',
  SET_VIEWER_SEGMENT_EQUIVALENCES: 'SET_VIEWER_SEGMENT_EQUIVALENCES',
  SET_VIEWER_SEGMENT_QUERY: 'SET_VIEWER_SEGMENT_QUERY',
  ADD_VIEWER_LAYER: 'ADD_VIEWER_LAYER',
  SELECT_VIEWER_LAYER: 'SELECT_VIEWER_LAYER',
  ALERT_ADD: 'ALERT_ADD',
  ALERT_DELETE: 'ALERT_DELETE',
  CLIO_SET_TOP_LEVEL_FUNC: 'CLIO_SET_TOP_LEVEL_FUNC',
  CLIO_RESET_TOP_LEVEL_FUNC: 'CLIO_RESET_TOP_LEVEL_FUNC',
  SET_CONNECTIONS_PANEL_MAIN: 'SET_CONNECTIONS_PANEL_MAIN',
  SET_CONNECTIONS_PANEL_WHICH: 'SET_CONNECTIONS_PANEL_WHICH',
  SET_CONNECTIONS_PANEL_DATA: 'SET_CONNECTIONS_PANEL_DATA',
};

export default constants;
